import React, {Component} from 'react';
import {Button, Form, Segment} from 'semantic-ui-react';
import ReportContainer from "../../containers/report_container";
import {DropzoneComponent} from "react-dropzone-component";
import {deleteImageFromReport} from "../../data/report_api";

const uuidv1 = require('uuid/v1');

class AddNewDisclaimerNotes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            disclaimerDesc: undefined,
            attachments: [],
            title: undefined,
            type: undefined,
            typeInvalid: false
        };
    }

    handleSubmit = () => {
        if (!this.state.type) {
            this.setState({typeInvalid: true});
            return null;
        }
        this.setState({isCreating: true});
        const newDisclaimer = {
            client_id: uuidv1(),
            description: this.state.disclaimerDesc,
            title: this.state.title,
            section_type: this.state.type,
            action: 'create',
            images: this.state.attachments
        };
        this.props.addNewDisclaimer(newDisclaimer);
        this.props.flipShowAddSection();
        this.setState({isCreating: false});
    };

    removingFile = (file) => {
        let attachments = this.state.attachments;
        if (attachments.indexOf(file) !== -1) {
            attachments.splice(attachments.indexOf(file), 1);
        }
        return attachments;
    };

    render() {
        const moduleTypeOptions = [
            {key: 0, text: "Disclaimer", value: "disclaimer"},
            {key: 1, text: "Customer Service Note", value: "customer_service"},
            {key: 2, text: "General Notes", value: "notes"},
        ];
        let dropZone = null;
        const componentConfig = {postUrl: 'no-url'};

        let djsConfig = {
            autoProcessQueue: false,
            addRemoveLinks: true,
            acceptedFiles: "image/jpeg, image/png, image/gif, application/pdf",
        };
        const eventHandlers = {
            init: (dropzone) => {
                dropZone = dropzone;
                dropZone.autoDiscover = false;
            },
            addedfile: (file) => {
                let imageObj = {
                    id: file.upload.uuid,
                    file: file,
                };
                // imageObj['image'] = imageObj;
                let attachments = this.state.attachments;
                attachments.push(imageObj);
                this.setState({attachments});
            },
            removedfile: (file) => {
                this.setState({attachments: this.removingFile(file)});
            }
        };
        return (<div className="pad-all add-receipt-segment">
            <Segment>
                <Form onSubmit={this.handleSubmit}>
                    <div style={{padding: "0 1%"}}>
                        <Form.Dropdown
                            label="Module Type"
                            required
                            selection
                            error={this.state.typeInvalid}
                            wrapSelection={false}
                            selectOnBlur={false}
                            options={moduleTypeOptions}
                            value={this.state.type}
                            placeholder='Module Type'
                            onFocus={() => this.setState({typeInvalid: false})}
                            onChange={(e, option) => {
                                this.setState({type: option.value})
                            }}
                        />
                        <Form.Input
                            placeholder='Title'
                            required
                            label="Title"
                            onFocus={(e) => {
                                this.setState({title: e.target.value});
                            }}
                            onChange={(e) => {
                                this.setState({title: e.target.value});
                            }}
                        />
                        <Form.TextArea
                            placeholder='Description'
                            rows='4'
                            required
                            label="Description"
                            onFocus={(e) => {
                                this.setState({disclaimerDesc: e.target.value});
                            }}
                            onChange={(e) => {
                                this.setState({disclaimerDesc: e.target.value});
                            }}
                        />
                        <Form.Field>
                            <label>Images</label>
                            <DropzoneComponent config={componentConfig}
                                               eventHandlers={eventHandlers}
                                               djsConfig={djsConfig}/>
                        </Form.Field>
                        <Button content="Add New Disclaimer/Notes" primary/>
                    </div>
                </Form>
            </Segment></div>)
    }
}

export default ReportContainer(AddNewDisclaimerNotes);


// WEBPACK FOOTER //
// ./src/views/report/add_new_disclaimer_notes.js